<template>
  <div class="logo-box">
<!--    <el-image :src="logo" ></el-image>-->

    <el-image v-if="config" style="width: 800px; height: 80px" :src="config.logo" fit="scale-down" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "LogoBox",
  computed: {
    ...mapState(['config'])
  },
}
</script>

<style scoped>
.logo-box {
  width: 1200px;
  margin: 0 auto;
  background: url('../assets/images/logo_background.png');
  background-size: 100%;
  height: 12rem;
  display: flex;
  align-items: center;
}
.logo {
  width: 800px;
  height: 80px;
}
</style>